import type { AxiosInstance } from 'axios';
import type {
    CollectionApprovedTokensResponse,
    CollectionCommissionResponse,
    ContractSettingsListResponse
} from '~/service/api/types';

export default (axiosInstance: AxiosInstance) => ({
    /**
   * @description retrieve approved erc20 tokens by network name
   *
   * @tags collection
   * @name ApprovedErc20Tokens
   * @request GET:/collection/approved-tokens/{network}
   * @response `200` `ApprovedErc20TokensData` success getting commissions list
   * @response `default` `EmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any content answers
   */
    async approvedErc20Tokens(network: User['network']) {
        const res = await axiosInstance.get<CollectionApprovedTokensResponse>(
            `/v1/collections/approved-tokens/${network}`
        );

        return res.data;
    },

    /**
   * @description retrieve commission by id
   *
   * @tags collection
   * @name commissionById
   * @request GET:/collection/commission/{slug}
   * @response `200` `CommissionByIdData` success getting commission data
   * @response `default` `ApiEmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any data answers
   */
    async commissionById(slug: string, params = {}) {
        const res = await axiosInstance.get<CollectionCommissionResponse>(
            `/v1/collections/commission/${slug}`,
            {
                params: {
                    ...params
                }
            }
        );
        return res.data;
    },

    /**
     * @description list of contracts settings
     *
     * @tags collection
     * @name ContractSettingsList
     * @request GET:/contract/router/settings
     * @response `200` `ContractSettingsListData` success getting contracts settings
     * @response `default` `EmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any data answers
     */
    async contractSettingsList() {
        const res = await axiosInstance.get<ContractSettingsListResponse>(
            `/v1/contract/router/settings`
        );
        return res.data;
    }
} as const);
